module.exports = __webpack_public_path__ + "static/media/15a.6bd858d6.jpg";